import { MessageSquareShare } from "lucide-react";
import { cn } from "@/lib/utils";

export function Logo({ className, showSub = false, size = "default" }) {
  const iconSize = size === "lg" ? "h-9 w-9" : "h-7 w-7";
  const textSize = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="app-logo">
      <div className={cn("flex items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm", size === "lg" ? "h-11 w-11" : "h-9 w-9")}>
        <MessageSquareShare className={iconSize} strokeWidth={2.2} />
      </div>
      <div className="leading-tight">
        <span className={cn("font-heading font-semibold tracking-tight text-foreground", textSize)}>
          Connectivity
        </span>
        {showSub && (
          <p className="text-xs text-muted-foreground">Business messaging, connected.</p>
        )}
      </div>
    </div>
  );
}
